import { useCallback, useEffect, useState } from "react";
import setByPath from "utils/setByPath";

/**
 * Establece el valor de una propiedad de la entidad
 * @callback SetValue
 * @param {any} e Value
 * @returns {void}
 */

/**
 * Establece un nuevo valor para la entidad
 * @callback Reset
 * @param {any} [newEntity] Entidad
 * @param {bool} [waitReset] Espera primer reseteo para iniciar formulario
 * @returns {void}
 */

/**
 * Obtiene y actualiza las propiedades de una entidad
 * @template T Entidad
 * @param {T} initialEntity Entidad a gestionar
 * @return {{entity: T, refKey: number, isFormReady: bool, setValue: SetValue, reset: Reset }}
*/
const useFormState = (initialEntity = {}, waitReset = false) => {
    const [entity, setEntity] = useState(JSON.parse(JSON.stringify({...initialEntity})));
    const [refKey, setRefKey] = useState(new Date().getMilliseconds());
    const [isFormReady, setIsFormReady] = useState(false);

    /*const setValue = useCallback((e) => {
        const { name, value } = e.target;
        setEntity(prev => setByPath(prev, name, value));
    }, []);*/

    const setValue = useCallback((e) => {
        const { name, value } = e.target;
        setEntity(prev => {
            const nextValue = typeof value === 'function' ? value(prev) : value;
            return setByPath(prev, name, nextValue);
        });
    }, []);

    const reset = useCallback((newEntity = undefined) => {
        setEntity(newEntity ?? JSON.parse(JSON.stringify({...initialEntity})));
        setRefKey(new Date().getMilliseconds());
        setIsFormReady(true);
    }, [initialEntity]);

    useEffect(() => {
        if(!waitReset) setIsFormReady(true);
    }, [waitReset]);
  
    return {
      entity,
      refKey,
      isFormReady,
      setValue,
      reset,
    };
};

export default useFormState;